/* Accessify widget — PDP offset to clear sticky ATC pill.
 *
 * Why this exists as JS, not CSS:
 *   The widget injects `style="bottom: 3% !important"` inline via its
 *   own runtime, AFTER the page's CSS applies. Inline !important always
 *   beats stylesheet !important in the cascade. Our only path is to
 *   override the inline style directly via JS, and re-assert it whenever
 *   the widget re-mutates the style attribute.
 *
 * Legal cleared: briefs/output/design/legal-accessibility-widget-2026-05-19.md.
 * Real selector verified by DOM-inspect 2026-05-19 pm:
 *   <div id="accessify-widget-btn" class="widget-toggle" style="...">
 *
 * Behaviour:
 *   - Runs ONLY on product templates (body.template-product).
 *   - Lifts the widget to bottom: 88px on PDPs.
 *   - Uses MutationObserver on the widget's `style` attribute so that
 *     any widget-internal re-application of `bottom: 3%` gets re-overridden.
 *   - Lives behind a DOMContentLoaded listener so it doesn't block render.
 *   - Polls for up to 10 seconds for the widget to mount, since it loads async.
 */
(function () {
  'use strict';

  // Scope guard: PDP always; homepage on mobile only (FIX 5, 2026-08-11).
  var isProduct = document.body.classList.contains('template-product');
  var isIndex   = document.body.classList.contains('template-index');
  var isMobile  = window.matchMedia('(max-width: 767.98px)').matches;
  if (!isProduct && !(isIndex && isMobile)) return;

  var TARGET_BOTTOM = isProduct ? '88px' : '150px';
  var WIDGET_SELECTOR = '#accessify-widget-btn';
  var MAX_WAIT_MS = 10000;
  var POLL_INTERVAL_MS = 200;

  function applyOffset(el) {
    if (!el) return;
    // Set with !important via setProperty
    el.style.setProperty('bottom', TARGET_BOTTOM, 'important');
  }

  function watchAndReassert(el) {
    applyOffset(el);
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'style') {
          var current = el.style.getPropertyValue('bottom');
          if (current !== TARGET_BOTTOM) {
            applyOffset(el);
          }
        }
      });
    });
    mo.observe(el, { attributes: true, attributeFilter: ['style'] });
  }

  function init() {
    var started = Date.now();
    var existing = document.querySelector(WIDGET_SELECTOR);
    if (existing) {
      watchAndReassert(existing);
      return;
    }
    // Widget mounts async — poll for it.
    var iv = setInterval(function () {
      var el = document.querySelector(WIDGET_SELECTOR);
      if (el) {
        clearInterval(iv);
        watchAndReassert(el);
      } else if (Date.now() - started > MAX_WAIT_MS) {
        clearInterval(iv);
        // Widget never mounted on this PDP — silent no-op.
      }
    }, POLL_INTERVAL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
